import React from 'react'
import { useIntl } from 'react-intl'
import { TowingRecordServiceType } from '../../common/types'
import { FormSubGroup, FormSubGroupHeading, ImageWrapper, Section, SectionColumn } from '../../components/layout'
import { DateInput, NumberInput, SelectInput, TextAreaInput, TextInput } from '../../components/layout/form/input'
import { ALFormSubGroupHeader, ALFormSubGroupWrapper } from '../ALOrderSubForm'
import autoliitto from '../../images/autoliitto.png'
import { AlArcCodesForm } from '../AlArcCodesForm'
import { useFormikHelpers } from '../../util/useFormikHelpers'
import { formatMessageSafe } from '../../util/translateInputOptions'
import { messages } from './messages'

interface ALSubFormProps {
  serviceTypeOptions: object[]
  serviceType?: TowingRecordServiceType
}

export const ALSubForm: React.FC<ALSubFormProps> = ({ serviceTypeOptions }) => {
  const { getValue } = useFormikHelpers()
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)
  return (
    <ALFormSubGroupWrapper>
      <ALFormSubGroupHeader>
        <FormSubGroupHeading>
          <ImageWrapper>
            <img src={autoliitto} alt="AL" width={`95px`} />
          </ImageWrapper>
        </FormSubGroupHeading>
      </ALFormSubGroupHeader>
      <FormSubGroup>
        <Section>
          <SectionColumn>
            <DateInput label={formatMessage(messages.date)} name="jobDetails.towingDate" />
          </SectionColumn>
          <SectionColumn>
            <NumberInput
              label={formatMessage(messages.vehicleMileage)}
              name="automobileAndTouringClubFinland.vehicleMileage"
              decimals={0}
            />
          </SectionColumn>
          <SectionColumn>
            <TextInput label={formatMessage(messages.caseNumber)} name="automobileAndTouringClubFinland.caseNumber" disabled />
          </SectionColumn>
          <SectionColumn>
            <TextInput label={formatMessage(messages.billingInfo)} name="automobileAndTouringClubFinland.billingInfo" disabled />
          </SectionColumn>
          <SectionColumn>
            <NumberInput
              label={formatMessage(messages.personCount)}
              name="automobileAndTouringClubFinland.personCount"
              decimals={0}
            />
          </SectionColumn>
          <SectionColumn>
            <TextInput
              label={formatMessage(messages.serviceChannel)}
              name="automobileAndTouringClubFinland.serviceChannel"
              disabled
            />
          </SectionColumn>
        </Section>
        <Section>
          <SectionColumn>
            <SelectInput label={formatMessage(messages.serviceType)} name="jobDetails.serviceType" options={serviceTypeOptions} />
          </SectionColumn>
          <AlArcCodesForm serviceType={getValue("jobDetails.serviceType")} />
        </Section>
        <Section columns={2}>
          <SectionColumn>
            <TextAreaInput label={formatMessage(messages.additionalInfo)} name="jobDetails.additionalInfo" />
          </SectionColumn>
          <SectionColumn>
            <TextAreaInput label={formatMessage(messages.notes)} name="jobDetails.notes" />
          </SectionColumn>
        </Section>
      </FormSubGroup>
    </ALFormSubGroupWrapper>
  )
}
